import React, { useEffect, useRef, useState } from "react";
import "./Songbook.scss";
import LeftSidebar from "../../components/layout/LeftSidebar/LeftSidebar";
import RightSidebar from "../../components/layout/RightSidebar/RightSidebar";
import SongEditor from "../../components/widgets/SongEditor/SongEditor";
import { Songbook } from "../../@core/models";
import RestClient from "../../@core/restClient";
import { useParams } from "react-router-dom";
import draftToHtml from "draftjs-to-html";
import {
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
  IoDesktopOutline,
  IoDownload,
  IoPencilOutline,
  IoPrint,
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoCopyOutline,
  IoMusicalNotesSharp,
  IoChatbubbleEllipsesOutline
} from "react-icons/io5";
import SongFullScreen from "../../components/widgets/UI/SongFullScreen";
import Spinner from "../../components/widgets/UI/Spinner";
import FileLoadModal from "../../components/widgets/UI/FileLoadModal";
import VideoBox from "../../components/widgets/UI/VideoBox";
import AudioBox from "../../components/widgets/UI/AudioBox";
import CopySong from "../../components/widgets/UI/CopySong";
import { Auth } from "../../@core/auth";
import { ImFontSize } from "react-icons/im";
import { divide } from "lodash";
//import { divide, forEach } from "lodash";
//import { original } from "@reduxjs/toolkit";

type EditModeState = [
  editMode: boolean,
  setEditMode: (editMode: boolean) => void
];
type CreateModeState = [
  editMode: boolean,
  setEditMode: (editMode: boolean) => void
];

type SongbookState = [
  songbook: Songbook | null,
  setSongbook: (songbook: Songbook) => void
];

interface ToggleSidebar {
  left: boolean;
  right: boolean;
}

type ToggleSidebarState = [
  openSidebar: ToggleSidebar,
  setOpenSidebar: (openSidebar: ToggleSidebar) => void
];

const DEFAULT_SONG = {
  title: "",
  songbookId: null,
  key: "",
  time: "",
  tempo: "",
  text: "",
  categories: [],
  files: []
};

const BRAKEPOINT = 992;

const musicKey = [
  "Ab",
  "Abm",
  "A",
  "Am",
  "A#",
  "A#m",
  "Bb",
  "Bbm",
  "B",
  "Bm",
  "C",
  "Cm",
  "C#",
  "C#m",
  "Db",
  "Dbm",
  "D",
  "Dm",
  "D#",
  "D#m",
  "Eb",
  "Ebm",
  "E",
  "Em",
  "F",
  "Fm",
  "F#",
  "F#m",
  "G",
  "Gm",
  "G#",
  "G#m"
];

const flatKey = [
  "C",
  "G",
  "D",
  "A",
  "E",
  "B",
  "Gb",
  "Db",
  "Ab",
  "Eb",
  "Bb",
  "F"
];
const sharpKey = [
  "C",
  "G",
  "D",
  "A",
  "E",
  "B",
  "F#",
  "C#",
  "G#",
  "D#",
  "A#",
  "F"
];

const chordCheck = [
  "Ab",
  "Eb",
  "Bb",
  "Gb",
  "Db",
  "F#",
  "C#",
  "G#",
  "D#",
  "A#",
  "F",
  "C",
  "G",
  "D",
  "A",
  "E",
  "B"
];

const SongbookPage = () => {
  const { songbookId, songId } = useParams();
  const [editMode, setEditMode]: EditModeState = useState(false);
  const [createMode, setCreateMode]: CreateModeState = useState(false);
  const [song, setSong] = useState<any>(DEFAULT_SONG);
  const [songbook, setSongbook]: SongbookState = useState<Songbook | null>(
    null
  );
  const [openSidebar, setOpenSidebar]: ToggleSidebarState =
    useState<ToggleSidebar>({
      left: window.innerWidth >= BRAKEPOINT,
      right: window.innerWidth >= BRAKEPOINT
    });
  const [screenMode, setScreenMode] = useState(false);
  const [forScreen, setForScreen] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [songCategories, setSongCategories] = useState<any[]>([]);
  const [songListModified, setSongListModified] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [userId, setUserId] = useState<any>(
    JSON.parse(localStorage.getItem("User") || "{}")?.id
  );
  const [collabPermission, setCollabPermission] = useState(false);
  const [title, setTitle] = useState("Іде завантаження . . .");
  const [noSongsMessage, setNoSongsMessage] = useState("");
  const [mediaPermission, setMediaPermission] = useState(false);
  const [bookPrivate, setBookPrivate] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [mediaMessage, setMediaMessage] = useState(false);
  const [songsLimit, setSongsLimit] = useState(false);
  const [songsLimitMessage, setSongsLimitMessage] = useState(false);
  const [keyList, setKeyList] = useState(false);
  const [noChords, setNoChords] = useState(false);
  const [originalKey, setOriginalKey] = useState(song.key);
  const [newKey, setNewKey] = useState("Am");
  const [isLoading, setIsLoading] = useState(false);
  const [noSongs, setNoSongs] = useState(false);
  const [fileLoadOpen, setFileLoadOpen] = useState(false);
  const [videoBoxOpen, setVideoBoxOpen] = useState(false);
  const [videoLink, setVideoLink] = useState("");
  const [audioLink, setAudioLink] = useState("");
  const [audioBoxOpen, setAudioBoxOpen] = useState(false);
  const [copySongOpen, setCopySongOpen] = useState(false);
  const [fontSize, setFontSize] = useState(localStorage.getItem("font") || 1.8);

  const text = useRef() as React.MutableRefObject<HTMLDivElement>;
  const allText = useRef() as React.MutableRefObject<HTMLDivElement>;
  const editorRef = useRef<{
    resetEditor: () => void;
    setContent: (text: string) => void;
  }>(null);

  //CHANGING FONT SIZE

  const changeFontUp = () => {
    const newSize = Number(fontSize) + 0.1;
    setFontSize(newSize);
    localStorage.setItem("font", String(newSize));
  };
  const changeFontDown = () => {
    const newSize = Number(fontSize) - 0.1;
    setFontSize(newSize);
    localStorage.setItem("font", String(newSize));
  };

  //OPEN COPY SONG

  const openCopySong = () => {
    setCopySongOpen(true);
  };
  const closeCopySong = () => {
    setCopySongOpen(false);
  };

  //OPEN VIDEO BOX
  const openVideoBox = (link: any) => {
    setVideoBoxOpen(true);
    setAudioBoxOpen(false);
    setVideoLink(link);
  };
  const closeVideoBox = () => {
    setVideoBoxOpen(false);
  };

  //OPEN AUDIO BOX
  const openAudioBox = (link: any) => {
    setAudioBoxOpen(true);
    setVideoBoxOpen(false);
    setAudioLink(link);
  };

  const closeAudioBox = () => {
    setAudioBoxOpen(false);
  };

  //OPEN FILE LOAD MODAL
  const openFileLoadModal = (e: any) => {
    //e.stopPropagation();
    setFileLoadOpen(true);
  };
  const closeFileLoadModal = () => {
    setFileLoadOpen(false);
  };

  //CHNAGE KEY
  const check =
    ///A|B|C|D|E|F|G/;
    // /^(\s*|&nbsp;|[A-G|:](#|b)?(m|maj|min|dim|aug|sus|add)?\d*(\/[A-G](#|b)?)?)+$/;
    /([A-G](#|b)?(m|maj|min|dim|aug|sus|add)?\d*(\/[A-G](#|b)?)?)+/;
  const exclude =
    /c|e|f|g|h|g|k|l|o|q|r|t|v|w|y|z|VERSE|CHORUS|TAG|VAMP|INTRO|BRIDGE|PRE/;
  //const extraLines = /.*\([^)]*\).*/;
  const extraLines = /[()]/;
  const verseLine = /[%]/;
  const chorusLine = /[$]/;
  const bridgeLine = /[@]/;

  const changeKey = (item: any) => {
    setNewKey(item);
    if (createMode || editMode) {
      setSong({ ...song, key: item });
    }
  };
  useEffect(() => {
    setOriginalKey(song.key);
  }, [editMode, createMode]);

  useEffect(() => {
    setIsLoading(true);

    let shift = 0;
    let startKey = 0;
    let endKey = 0;
    const splitOriginal = originalKey.replace("m", "");
    const splitNewKey = newKey.replace("m", "");
    if (splitOriginal.includes("#")) {
      startKey = sharpKey.indexOf(splitOriginal) + 1;
    } else {
      startKey = flatKey.indexOf(splitOriginal) + 1;
    }

    if (splitNewKey.includes("#")) {
      endKey = sharpKey.indexOf(splitNewKey) + 1;
    } else {
      endKey = flatKey.indexOf(splitNewKey) + 1;
    }

    if (startKey > endKey) {
      shift = flatKey.length - startKey + endKey;
    } else {
      shift = endKey - startKey;
    }

    // IF EDIT MODE

    if (editMode) {
      Array.from(allText.current?.getElementsByTagName("span") || []).forEach(
        (item: any) => {
          const checked = item.innerHTML.match(check);
          const excluded = item.innerHTML.match(exclude);
          if (checked && excluded === null) {
            chordCheck.forEach((chord) => {
              let str = "";
              let oldI = 0;
              let newChord = "";
              const checkChord = new RegExp(`\\b${chord}(?![#b])`, "g");
              const checkKey = new RegExp(
                "(D|E|G|A|B|C#|F#|G#|A#)(?![#b])",
                "g"
              );

              if (item.innerHTML.match(checkChord)) {
                if (chord.includes("b")) {
                  oldI = flatKey.indexOf(chord);
                } else {
                  oldI = sharpKey.indexOf(chord);
                }
                if (newKey.match(checkKey)) {
                  newChord = `-${sharpKey[(oldI + shift) % 12]}`;
                } else {
                  newChord = `-${flatKey[(oldI + shift) % 12]}`;
                }
                const re = new RegExp(`(?<!-)${chord}`, "g");
                str = item.innerHTML.replaceAll(re, newChord);
                item.innerHTML = str;
              }
            });
            const final = item.innerHTML.replaceAll("-", "");
            item.innerHTML = final;
          } else {
            return;
          }
        }
      );
      //editorRef.current?.resetEditor();
      editorRef.current?.setContent(allText.current.innerText);
      startKey = 0;
      endKey = 0;
      shift = 0;
    } else {
      Array.from(text.current?.children || []).forEach((item: any) => {
        const checked = item.innerHTML.match(check);
        const excluded = item.innerHTML.match(exclude);
        if (checked && excluded === null) {
          chordCheck.forEach((chord) => {
            let str = "";
            let oldI = 0;
            let newChord = "";
            const checkChord = new RegExp(`\\b${chord}(?![#b])`, "g");
            const checkKey = new RegExp("(D|E|G|A|B|C#|F#|G#|A#)(?![#b])", "g");
            if (item.innerHTML.match(checkChord)) {
              if (chord.includes("b")) {
                oldI = flatKey.indexOf(chord);
              } else {
                oldI = sharpKey.indexOf(chord);
              }
              if (newKey.match(checkKey)) {
                newChord = `-${sharpKey[(oldI + shift) % 12]}`;
              } else {
                newChord = `-${flatKey[(oldI + shift) % 12]}`;
              }
              const re = new RegExp(`(?<!-)${chord}`, "g");
              str = item.innerHTML.replaceAll(re, newChord);
              item.innerHTML = str;
            }
          });

          const final = item.innerHTML.replaceAll("-", "");
          item.innerHTML = final;
        } else {
          return;
        }
      });
    }
    setIsLoading(false);
    startKey = 0;
    endKey = 0;
    shift = 0;
    setOriginalKey(newKey);
  }, [newKey]);

  //HIDE AND SHOW CHORDS

  useEffect(() => {
    const storedChords = localStorage.getItem("noChords");
    setNoChords(!!(storedChords && JSON.parse(storedChords)));
  }, []);
  const toggleChords = () => {
    if (noChords) {
      setNoChords(false);
      localStorage.setItem("noChords", JSON.stringify(false));
    } else {
      setNoChords(true);
      localStorage.setItem("noChords", JSON.stringify(true));
    }
  };

  //HIDE AND SHOW COMMENTS

  const toggleComments = () => {
    if (showComments) {
      setShowComments(false);
    } else {
      setShowComments(true);
    }
  };
  //MAKING CHORDS BLUE

  useEffect(() => {
    Array.from(text.current?.children || []).forEach((item) => {
      const checked = item.innerHTML.match(check);
      const excluded = item.innerHTML.match(exclude);
      const comments = item.innerHTML.match(extraLines);
      const verse = item.innerHTML.match(verseLine);
      const chorus = item.innerHTML.match(chorusLine);
      const bridge = item.innerHTML.match(bridgeLine);
      if (noChords && checked && excluded === null) {
        item.classList.add("hide");
        return;
      } else {
        item.classList.remove("hide");
      }
      if (checked && !noChords && excluded === null) {
        item.classList.add("chords");
      } else {
        item.classList.remove("chords");
      }
      if (comments) {
        item.classList.add("comments");
      } else {
        item.classList.remove("comments");
      }
      if (comments && !showComments) {
        item.classList.add("hide");
      } else {
        item.classList.remove("hide");
      }
      if (verse) {
        item.classList.add("verse");
        const final = item.innerHTML.replaceAll("%", "");
        item.innerHTML = final;
      } else if (chorus) {
        item.classList.add("chorus");
        const final = item.innerHTML.replaceAll("$", "");
        item.innerHTML = final;
      } else if (bridge) {
        item.classList.add("bridge");
        const final = item.innerHTML.replaceAll("@", "");
        item.innerHTML = final;
      } else {
        return;
      }
    });
  }, [noChords, song, showComments]);

  // PERMISSIONS

  const songsNumber = (snumber: number) => {
    if (Auth.isBookOwnerUser && snumber >= 15) {
      // setSongsLimit(true);  When tunring this back on, setSongsLimint Message in create function , too
      setSongsLimit(false);
    } else {
      setSongsLimit(false);
    }
  };

  useEffect(() => {
    const timeoutUser = setTimeout(() => {
      (async () => {
        try {
          if (!songbookId) {
            return;
          }
          const bookOwner: any = await RestClient.getUserById(
            songbook?.ownerId
          );
          Auth.songbookOwner = bookOwner;
        } catch (error) {
          console.log("error");
        }
      })();
    }, 2000); // 2000 ms = 2 seconds

    return () => clearTimeout(timeoutUser);
  }, [songbook]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const colls = songbook?.collaborators.map((item: any) => item.id);
      // let isCollaborator = false;
      // if (colls?.includes(Number(userId))) {
      //   isCollaborator = true;
      // } else {
      //   isCollaborator = false;
      // }

      // if (
      //   (Auth.isAuthenticated && userId === Number(songbook?.ownerId)) ||
      //   (Auth.isAuthenticated && isCollaborator && Auth.isBookOwnerAdmin) ||
      //   (Auth.isAuthenticated && isCollaborator && Auth.isBookOwnerTeamPaid)
      // ) {
      //   setMediaPermission(true);
      //   setCollabPermission(true);
      // } else {
      //   setMediaPermission(false);
      //   setCollabPermission(false);
      // }

      // if (Auth.isBookOwnerUser) {
      //   setMediaMessage(true);
      // } else {
      //   setMediaMessage(false);
      // }

      if (
        (Auth.isAuthenticated && userId === Number(songbook?.ownerId)) ||
        (Auth.isAuthenticated && colls?.includes(Number(userId)))
      ) {
        setCollabPermission(true);
        setMediaPermission(true);
      } else {
        setCollabPermission(false);
        setMediaPermission(false);
      }
    }, 1500); // 2000 ms = 2 seconds

    return () => clearTimeout(timeoutId);
  }, [songbook, createMode, deleteModal]);

  //CATEGORIES
  useEffect(() => {
    (async () => {
      try {
        const response = await RestClient.getCategoryList();
        setCategoryList(response || []);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const addCategories = (event: any) => {
    const value = Number(event.target.value);
    const isChecked = event.target.checked;
    if (isChecked === true) {
      setSongCategories((oldValue) => [...oldValue, value]);
    } else {
      const filteredList = songCategories.filter((item) => item !== value);
      setSongCategories(filteredList);
    }
  };

  const closeFullScreen = () => {
    setScreenMode(false);
  };

  const toggleSidebar = (sidebar: "left" | "right", e: any) => {
    if (sidebar === "left") {
      e.stopPropagation();
      setOpenSidebar({ ...openSidebar, left: !openSidebar.left });
    } else if (sidebar === "right") {
      e.stopPropagation();
      setOpenSidebar({ ...openSidebar, right: !openSidebar.right });
    }
  };
  const closeBothSideBars = () => {
    setOpenSidebar({ ...openSidebar, left: false, right: false });
  };

  useEffect(() => {
    if (window.innerWidth <= 992) {
      if (openSidebar.left) {
        document.body.addEventListener("click", () => {
          setOpenSidebar({ ...openSidebar, left: !openSidebar.left });
        });
      } else if (openSidebar.right) {
        document.body.addEventListener("click", () => {
          setOpenSidebar({ ...openSidebar, right: !openSidebar.right });
        });
      } else {
        return;
      }
    } else {
      return;
    }
  }, [openSidebar]);

  const create = (e: any) => {
    if (Auth.isAuthenticated) {
      if (songsLimit) {
        if (window.innerWidth <= 992) toggleSidebar("right", e);
        setSongsLimitMessage(true);
        return;
      } else {
        setNewKey("");
        setCreateMode(true);
        setSong(DEFAULT_SONG);
        setSongCategories([]);
        if (window.innerWidth <= 992) toggleSidebar("right", e);
      }
    } else {
      // reload();
      setUserId(null);
      return;
    }
  };

  const closeSidebar = (e: any) => {
    if (window.innerWidth <= BRAKEPOINT) toggleSidebar("left", e);
  };

  useEffect(() => {
    const matchMedia = window.matchMedia(`(min-width: ${BRAKEPOINT}px)`);
    const matchMediaEventHandler = (event: MediaQueryListEvent) => {
      setOpenSidebar({ left: event.matches, right: event.matches });
    };
    matchMedia.addEventListener("change", matchMediaEventHandler);
    return () => {
      matchMedia.removeEventListener("change", matchMediaEventHandler);
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (!songbookId) {
          return;
        }
        const book: any = await RestClient.getSongbook(songbookId);
        setSongbook(book || {});
        if (!book) {
          setTitle("Не знайдено");
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await getSong();
    })();
  }, [songId]);

  const getSong = async () => {
    setCreateMode(false);
    setNoSongs(false);
    try {
      setIsLoading(true);
      if (!songId) {
        setSong(DEFAULT_SONG);
        setIsLoading(false);
        setNoSongs(true);
        // setNoSongsMessage("Тут пісень ще немає");
        return;
      }
      const data = await RestClient.getSong(songId);
      if (!data) {
        setNoSongsMessage("Тут пісень ще немає");
      } else {
        const song = {
          id: data.id,
          title: data.title,
          songbookId: data.songbookId,
          key: data.key,
          time: data.time,
          tempo: data.tempo,
          text: data.text,
          categories: data.categories,
          files: data.files
        };
        setSong(song || {});
        setEditMode(false);
        setForScreen([song]);
        setSongCategories(
          data.categories?.map((category) => category.id) || []
        );
        //setNoChords(false);
        setOriginalKey(song.key);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const saveSong = async (songId: any) => {
    setIsLoading(true);
    if (createMode) {
      try {
        const addedSong = await RestClient.addSong({
          ...song,
          songbookId: songbook?.id,
          categories: songCategories
        });
        setCreateMode(false);
        setSongListModified(true);
        setTimeout(() => {
          setSongListModified(false);
        }, 3000);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        delete song.id;
        const updatedSong = await RestClient.updateSong(songId, {
          ...song,
          categories: songCategories
        });
        getSong();
        setEditMode(false);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const openDeleteSong = (e: any) => {
    if (window.innerWidth <= 992) {
      toggleSidebar("right", e);
    }
    setDeleteModal(true);
  };

  const deleteSong = () => {
    try {
      (async () => {
        const deletedSong = await RestClient.deleteSong(song.id);
        if (deletedSong) {
          setDeleteModal(false);
          setSongListModified(true);
          setTimeout(() => setSongListModified(false), 300);
        }
      })();
    } catch (error) {
      console.log("error");
    }
  };

  useEffect(() => {
    const content = document.getElementById("songBody");
    if (screenMode && content) {
      content.style.position = "fixed";
    }
    if (!screenMode && content) {
      content.style.position = "relative";
    }
  }, [screenMode]);

  const hideDeleteModal = () => {
    setDeleteModal(false);
  };

  useEffect(() => {
    if (deleteModal) {
      document.body.style.position = "fixed";
    }
    if (!deleteModal) {
      document.body.style.position = "relative";
    }
  }, [deleteModal]);

  useEffect(() => {
    if (editMode) {
      const existingCategories = document.querySelectorAll(".categories-item");
      existingCategories.forEach((item: any) => {
        if (songCategories.includes(Number(item.value))) {
          item.checked = true;
        }
      });
    } else {
      return;
    }
  }, [editMode]);

  const togleKeyList = (e: any) => {
    e.stopPropagation();
    setKeyList(!keyList);
  };

  useEffect(() => {
    if (keyList) {
      document.body.addEventListener("click", () => {
        setKeyList(false);
      });
    } else {
      return;
    }
  }, [keyList]);

  //PRIVATE SONGS BOOK PERMISSION

  useEffect(() => {
    const setPrivateTimeOut = setTimeout(() => {
      const bookCollaborators = songbook?.collaborators.map(
        (person: any) => person.id
      );

      if (!songbook?.public) {
        if (Auth.isAuthenticated) {
          if (
            songbook?.ownerId === userId ||
            bookCollaborators?.includes(userId)
          ) {
            setBookPrivate(false);
          } else {
            setBookPrivate(true);
          }
        } else {
          setBookPrivate(true);
        }
      } else {
        setBookPrivate(false);
      }
    }, 500);
    return () => clearTimeout(setPrivateTimeOut);
  }, [songbook]);

  useEffect(() => {
    const noSongsMessageChange = setTimeout(() => {
      if (!song) {
        setNoSongsMessage("");
      } else {
        return;
      }
    }, 2000);
    return () => clearTimeout(noSongsMessageChange);
  }, [songbook]);

  return (
    <div className="songbook">
      {screenMode ? (
        <div>
          <SongFullScreen
            selectedSongs={forScreen}
            closeFullScreen={closeFullScreen}
          />
        </div>
      ) : null}
      <div className="title">
        <h2>{songbook?.title || title}</h2>
      </div>
      <div className="content-row" id="songBody">
        {bookPrivate ? null : (
          <div
            className={`toggler left_${openSidebar.left ? "open" : "close"}`}
            onClick={(e) => toggleSidebar("left", e)}
          >
            {openSidebar.left ? (
              <IoArrowBackCircleOutline />
            ) : (
              <IoArrowForwardCircleOutline />
            )}
          </div>
        )}
        {bookPrivate ? null : (
          <div className={`left ${openSidebar.left ? "open" : "close"}`}>
            <LeftSidebar
              songListModified={songListModified}
              closeSidebar={closeSidebar}
              useCategories={songbook?.useCategories}
              onSongsNumber={songsNumber}
            />
          </div>
        )}
        <div className="center">
          {audioBoxOpen ? (
            <AudioBox audioLink={audioLink} closeAudioBox={closeAudioBox} />
          ) : (
            ""
          )}
          <>
            {videoBoxOpen ? <div className="empty"></div> : ""}
            {!screenMode ? (
              <div className="tools">
                <div className="my-tooltip">
                  <button
                    className={
                      !showComments ? "chords-show-btn" : "chords-hide-btn"
                    }
                    onClick={() => toggleComments()}
                  >
                    <IoChatbubbleEllipsesOutline />
                  </button>
                  <span className="my-tooltip-text tooltips-songbook">
                    {showComments ? "Сховати замітки" : "Показати замітки"}
                  </span>
                </div>
                <div className="my-tooltip">
                  <button
                    className={noChords ? "chords-hide-btn" : "chords-show-btn"}
                    onClick={() => toggleChords()}
                  >
                    <IoMusicalNotesSharp />
                  </button>
                  <span className="my-tooltip-text tooltips-songbook">
                    {noChords ? "Показати акорди" : "Сховати акорди"}
                  </span>
                </div>

                <div className="my-tooltip">
                  <button
                    className="tool-icon"
                    onClick={() => {
                      setScreenMode(true);
                    }}
                  >
                    <IoDesktopOutline />
                  </button>
                  <span className="my-tooltip-text tooltips-songbook">
                    Повний екран
                  </span>
                </div>

                {collabPermission ? (
                  <div className="my-tooltip">
                    <button
                      className="tool-icon"
                      onClick={() => setEditMode(true)}
                    >
                      {<IoPencilOutline />}
                    </button>
                    <span className="my-tooltip-text tooltips-songbook">
                      Редагувати
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {Auth.isAuthenticated && !noSongs ? (
                  <div className="my-tooltip">
                    <button
                      className="tool-icon"
                      onClick={() => openCopySong()}
                    >
                      <IoCopyOutline />
                    </button>
                    <span className="my-tooltip-text tooltips-songbook">
                      Копіювати
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : null}
            <div className="change-font-size my-tooltip">
              Aa
              <div className="change-font-size-arrows">
                <IoChevronUpOutline className="icon" onClick={changeFontUp} />
                <IoChevronDownOutline
                  className="icon"
                  onClick={changeFontDown}
                />
              </div>
              <span className="my-tooltip-text tooltips-songbook">
                Розмір шрифта
              </span>
            </div>

            <div className="song">
              {noSongs ? <div className="noSongs">{noSongsMessage}</div> : ""}
              {isLoading ? <Spinner /> : ""}
              <div className="my-3">
                {editMode || createMode ? (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Назва пісні"
                    value={song?.title}
                    onInput={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setSong({ ...song, title: event.target.value })
                    }
                  />
                ) : (
                  <h3>{song?.title}</h3>
                )}
              </div>
              {noChords ? (
                ""
              ) : (
                <div className="data">
                  <div className="key">
                    {songId || createMode || editMode ? (
                      <>
                        <p onClick={(e) => togleKeyList(e)}>
                          Тональність:{" "}
                          <input
                            type="text"
                            className="input-box"
                            value={originalKey}
                            onChange={() =>
                              setSong({ ...song, key: originalKey })
                            }
                          />
                          {keyList ? (
                            <IoChevronUpOutline className="key-icon" />
                          ) : (
                            <IoChevronDownOutline className="key-icon" />
                          )}
                        </p>

                        {keyList ? (
                          <div className="key-select">
                            {musicKey.map((item, i) => (
                              <p
                                className="key-select-item"
                                key={i}
                                // onClick={
                                //   editMode || createMode
                                //     ? () => setSong({ ...song, key: item })
                                //     : changeKey
                                // }
                                onClick={() => changeKey(item)}
                              >
                                {item}
                              </p>
                            ))}
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="time">
                    {editMode || createMode ? (
                      <p>
                        {" "}
                        Розмір:
                        <input
                          type="text"
                          className="input-box"
                          value={song?.time}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => setSong({ ...song, time: event.target.value })}
                        />
                      </p>
                    ) : (
                      <p>
                        {" "}
                        {songId ? "Розмір:" : ""}
                        <span>{song?.time}</span>
                      </p>
                    )}
                  </div>
                  <div className="tempo">
                    {editMode || createMode ? (
                      <p>
                        Темп:
                        <input
                          type="text"
                          className="input-box"
                          value={song?.tempo}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => setSong({ ...song, tempo: event.target.value })}
                        />
                      </p>
                    ) : (
                      <p>
                        {" "}
                        {songId ? "Темп:" : ""}
                        <span>{song?.tempo}</span>
                      </p>
                    )}
                  </div>
                </div>
              )}
              {songbook?.useCategories ? (
                <div className="">
                  {editMode || createMode ? (
                    <>
                      <p className="category-title">Категорії:</p>
                      <div className=" categories">
                        {categoryList.map((item: any) => (
                          <div className="category" key={item.id}>
                            <input
                              readOnly
                              className="categories-item"
                              type="checkbox"
                              value={item.id}
                              name="categoryId"
                              id={item.id}
                              onClick={addCategories}
                            />
                            <label htmlFor={item.id}>{item.name}</label>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="show-categories">
                      <p>{songId ? "Категорії:" : ""}</p>

                      {song?.categories?.map((item: any) => (
                        <p className="show-categories-item" key={item.id}>
                          {item.name}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
              {editMode || createMode ? (
                <div>
                  <p className="highlightLine">
                    Підсвітити рядок кольором, дадайте у рядок символ:
                  </p>
                  <div className="colors">
                    <div className="colorBox verseColor">%</div>
                    <div className="colorBox chorusColor">$</div>
                    <div className="colorBox bridgeColor">@</div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="text" ref={allText}>
                {editMode || createMode ? (
                  <SongEditor
                    ref={editorRef}
                    row={song?.text || ""}
                    onRowChange={(row) => setSong({ ...song, text: row })}
                  />
                ) : (
                  <div
                    style={{ fontSize: `${fontSize}rem` }}
                    ref={text}
                    className="text-inner"
                    dangerouslySetInnerHTML={{
                      __html:
                        song && song.text
                          ? draftToHtml(JSON.parse(song.text))
                          : ""
                    }}
                  ></div>
                )}
              </div>
              {editMode || createMode ? (
                <div className="edit-action">
                  <button
                    className="btn-mcolor mx-3"
                    onClick={() => saveSong(songId)}
                  >
                    Зберегти
                  </button>
                  <button className="btn-plain mx-3" onClick={getSong}>
                    Скасувати
                  </button>
                </div>
              ) : null}
            </div>
          </>
        </div>
        <div className={`right ${openSidebar.right ? "open" : "close"}`}>
          <RightSidebar
            songId={songId}
            onCreate={create}
            openDeleteSong={openDeleteSong}
            collabPermission={collabPermission}
            openFileLoadModal={openFileLoadModal}
            fileLoadOpen={fileLoadOpen}
            openVideoBox={openVideoBox}
            openAudioBox={openAudioBox}
            closeBothSideBars={closeBothSideBars}
            mediaPermission={mediaPermission}
            songFiles={song.files}
          />
        </div>
        <div
          className={`toggler right_${openSidebar.right ? "open" : "close"}`}
          onClick={(e) => toggleSidebar("right", e)}
        >
          {openSidebar.right ? (
            <IoArrowForwardCircleOutline />
          ) : (
            <IoArrowBackCircleOutline />
          )}
        </div>
      </div>
      {deleteModal ? (
        <div className="delete">
          <div className="delete-box">
            <p className="delete-box-message">
              Видалити пісню <span>{song.title}</span> ?
            </p>
            <div className="delete-box-btns">
              <button
                className="btn-mcolor delete-box-btn "
                onClick={deleteSong}
              >
                Так
              </button>
              <button
                className="btn-plain delete-box-btn "
                onClick={hideDeleteModal}
              >
                Ні
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {songsLimitMessage ? (
        <div className="songlimit">
          <div className="songlimit-box">
            <p className="songlimit-box-message">
              У вашому тарифному плані діє обмеження по кількості пісень. Будь
              ласка, перейдість на більш розширеший тарифний план або видаліть
              якусь пісню. Перейти на інший тарифний план можна у персональному
              кабінеті.
            </p>
            <div>
              <button
                className="btn-mcolor delete-box-btn "
                onClick={() => setSongsLimitMessage(false)}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {fileLoadOpen ? (
        <FileLoadModal
          closeFileLoadModal={closeFileLoadModal}
          songId={songId}
          songTitle={song.title}
          mediaMessage={mediaMessage}
        />
      ) : (
        ""
      )}
      {copySongOpen ? (
        <CopySong closeCopySong={closeCopySong} song={song} />
      ) : (
        ""
      )}
      {videoBoxOpen ? (
        <VideoBox videoLink={videoLink} closeVideoBox={closeVideoBox} />
      ) : (
        ""
      )}
    </div>
  );
};

export default SongbookPage;

// {songId ? (
// ) : (
//   <h3 className="no-song my-3">Пісня не обрана</h3>
// )}
